/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import HeaderCheckBoxSelectList, { HeaderCheckBoxSelectListElement, HeaderListProps } from './HeaderCheckBoxSelectList';
import { ItemLoaders } from '../../../../core/loaders/ItemLoaders';
import { connect } from 'react-redux';
import ApiCollectionResponseInterface from '../../../../interfaces/api/ApiCollectionResponseInterface';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import { platformResellerConstants } from '../../../../modules/platformreseller/actions';
import PlatformResellerInterface from '../../../../interfaces/platform/PlatformResellerInterface';

interface HeaderPlatformResellerCollectionInterface extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<PlatformResellerInterface> | null;
}

interface HeaderPlatformResellerProps extends HeaderListProps {
    dispatch: any;
}

interface HeaderPlatformResellerState {
    items: Array<HeaderCheckBoxSelectListElement> | null;
}

class HeaderPlatformReseller extends PureComponent<HeaderPlatformResellerProps, HeaderPlatformResellerState> {
    protected loaderCall: ItemLoaders;

    constructor(props: HeaderPlatformResellerProps, context: any) {
        super(props, context);
        this.state = {
            items: null,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount(): void {
        const { extraValues } = this.props;
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_resellers')),
            platformResellerConstants.PLATFORM_RESELLER_LIST,
            [],
            [{ name: 'mainname', value: 'asc' }],
            (data: HeaderPlatformResellerCollectionInterface): void => {
                let items = new Array<HeaderCheckBoxSelectListElement>();
                if (data['hydra:totalItems'] && data['hydra:totalItems'] > 0) {
                    data['hydra:member']?.map((item: PlatformResellerInterface) => {
                        items.push({ name: item.mainname, value: item.id });
                    });
                    if (extraValues) {
                        this.extraValues(items);
                    }
                    this.setState({
                        items: items,
                    });
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }

    extraValues = (items: Array<HeaderCheckBoxSelectListElement>): void => {
        const { extraValues } = this.props;
        extraValues?.map((item) => {
            if (item.addToList) {
                items.push({
                    name: item.i18string,
                    value: item.value,
                });
            }
        });
    };

    handleChange = (numbers: Array<number>): void => {
        const { handleChange, fieldName } = this.props;
        handleChange(fieldName, numbers, this.state.items);
    };

    render(): React.ReactNode {
        const { fieldName } = this.props;
        const { items } = this.state;
        if (items) {
            return <HeaderCheckBoxSelectList handleChange={this.handleChange} elements={items} fieldName={fieldName} />;
        }
        return null;
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(HeaderPlatformReseller);
